"use strict";

exports.__esModule = true;
exports.BaseWrapper = BaseWrapper;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _base = _interopRequireDefault(require("../base"));
var _TooltipGlobals = require("../TooltipGlobals");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BaseThemeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "BaseThemeWrapper",
  componentId: "sc-16tvh2a-0"
})([".chart-tooltip{.bp6-popover-content{background:", " !important;}.bp6-tooltip .bp6-popover-arrow-fill{fill:", " !important;}}"], _base["default"].TooltipContentBackgroundColor, _base["default"].TooltipContentBackgroundColor);
function BaseWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(BaseThemeWrapper, null, /*#__PURE__*/_react["default"].createElement(_TooltipGlobals.TooltipGlobals, null), children);
}